export const yesNoTable = [
  { label: "S", id: true },
  { label: "N", id: false },
];
